export default "__VITE_ASSET__CVl3wxrc__"